<template>
  <div class="phoneBind">
    <div
      class="publicTitle display-flex justify-content-space-between align-items-center"
    >
      <h5 class="h5">
        <img src="../../assets/img/titleLine.png" alt /> 手机绑定
      </h5>
    </div>
    <div class="mid" >
      <div class="title" v-if="!isApprove">
        <h2>手机绑定</h2>
        <p class="lineb"></p>
      </div>
	  <div class="title" v-else>
	    <h2>更换手机号码</h2>
	    <p class="lineb"></p>
	  </div>
      <div class="from">
        <Form
          class="head-login"
          ref="from"
          :model="userData"
          :rules="rules"
          :label-width="120"
          :hide-required-mark="true"
        >
          <FormItem label="手机号码" prop="phone">
            <Input
              type="text"
              v-model="userData.phone"
              placeholder="请输入"
            ></Input>
          </FormItem>
          <FormItem class="code" ref="code" label="短信验证码" prop="code">
            <div class="display-flex" style="width:320px">
              <Input v-model="userData.code" placeholder="请输入验证码"></Input>
              <div class="send">
                <Button
                  :disabled="btnDisabled"
                  type="primary"
                  @click="handleSendCode('from')"
                  >{{ codeBtnText }}</Button
                >
              </div>
            </div>
          </FormItem>   
          <div id="save">
            <div class="display-flex">
              <FormItem>
                <Button
                  class="confirm"
                  type="primary"
                  @click="handleSubmit('from')"
                  >确认</Button
                >
              </FormItem>
              <FormItem>
                <Button class="back" type="primary" @click="$router.back()"
                  >返回</Button
                >
              </FormItem>
            </div>
          </div>
        </Form>
      </div>
    </div>
    <!-- <div class="mid idSuccess" v-else>
      <img src="../../assets/img/approveSuc.png" alt="" />
      <span>已绑定!</span>
      <i
        style=" display: inline-block;
      width: 250px;
      height: 1px;
      background: #ddd;
      margin-bottom: 29px;"
      ></i>
      <div class="info">
        <p class="name" v-if="userInfo.phone">
          手机关联号:
          {{
            `${userInfo.phone.slice(0, 3)}****${userInfo.phone.slice(
              userInfo.phone.length - 4,
              userInfo.phone.length
            )}`
          }}
        </p>
      </div>
      <div class="from">
        <Form class="head-login" :label-width="100" :hide-required-mark="true">
          <div id="save">
            <div class="display-flex">
              <FormItem>
                <Button class="confirm" type="primary" @click="isModal = true"
                  >解绑</Button
                >
              </FormItem>
              <FormItem>
                <Button class="back" type="primary" @click="$router.back()"
                  >返回</Button
                >
              </FormItem>
            </div>
          </div>
        </Form>
      </div>
    </div> -->
    <Modal
      title="解绑"
      :closable="false"
      footer-hide
      v-model="isModal"
      width="400"
      class-name="vertical-center-modal unbindModal"
    >
      <div class="mid">
        <div class="from">
          <Form
            ref="from1"
            :model="userData"
            :rules="rules"
            :label-width="120"
            :hide-required-mark="true"
          >
            <p class="unphone" v-if="userInfo.phone">
              当前手机号<i>
                {{
                  `${userInfo.phone.slice(0, 3)}****${userInfo.phone.slice(
                    userInfo.phone.length - 4,
                    userInfo.phone.length
                  )}`
                }}</i
              >
            </p>
            <FormItem class="code" ref="code" label="" prop="code">
              <div class="display-flex" style="width:320px">
                <Input
                  v-model="userData.code"
                  placeholder="请输入验证码"
                ></Input>
                <div class="send">
                  <Button
                    :disabled="btnDisabled"
                    type="primary"
                    @click="handleUnSendCode"
                    >{{ codeBtnText }}</Button
                  >
                </div>
              </div>
            </FormItem>
          </Form>
          <div slot="footer" class="footerBtn">
            <button
              type="button"
              class="confirm"
              :loading="btnLoading"
              @click="handleUnbind('from1')"
            >
              解绑
            </button>
          </div>
        </div>
      </div>
      <img
        class="closeIcon"
        @click="isModal = false"
        src="../../assets/img/close.png"
      />
    </Modal>
  </div>
</template>

<script>
import { postData, showLoading } from "../../assets/api/api.js";
export default {
  name: "phoneBind",
  props: [],
  components: {},
  data() {
    return {
      isModal: false,
      btnLoading: false,
      userInfo: {},
      isApprove: false,
      btnDisabled: false,
      codeBtnText: "点击发送",
      userData: {
        code: "",
        phone: "",
      },

      rules: {
        phone: [
          { required: true, message: "手机号码不能为空", trigger: "blur" },
          {
            pattern: /^((\+86)|(86))?1[34578][0-9]\d{8}$/,
            message: "手机号码格式不对",
          },
        ],
        code: [{ required: true, message: "验证码不能为空", trigger: "blur" }],
      },
    };
  },
  created() {
    this.userInfo = {
      name: this.$route.query.name,
      cztype: this.$route.query.cztype,
      zsnum: this.$route.query.zsnum,
      idcard: this.$route.query.idcard,
      phone: this.$route.query.phone,
    };
    if (this.userInfo.phone) {
      this.isApprove = true;
    } else {
      this.isApprove = false;
    }
  },

  mounted() {},
  computed: {},
  methods: {
    handleUnbind(name) {
      this.$refs[name].validateField("code", (valid) => {
        if (!valid) {
          var params = {
            phone: this.userInfo.phone,
            vercode: this.userData.code,
          };
          this.btnLoading = true;
          postData("student/clearPhone", params)
            .then((res) => {
              this.$Message.success("解绑成功");
              this.isModal = false;
              this.btnLoading = false;
              this.$router.back();
              var userData = this.$store.state.master;
              userData.user.phone =  "";
              if (localStorage.getItem("master")) {
                localStorage.setItem("master", JSON.stringify(userData));
              } else if (sessionStorage.getItem("master")) {
                sessionStorage.setItem("master", JSON.stringify(userData));
              }
              this.$store.commit("setMaster", userData);
            })
            .catch((err) => {
              this.btnLoading = false;
            });
        }
      });
    },
    handleUnSendCode() {
      var params = {
        phone: this.userInfo.phone,
        type: 3,
      };
      postData("student/sendSmsCode", params).then((res) => {
        this.$Message.success("发送成功,请注意查收");
        var time = 60;
        this.codeBtnText = time + "s后重发";
        var timer = setInterval(() => {
          if (time <= 0) {
            clearInterval(timer);
            this.codeBtnText = "点击发送";
            this.btnDisabled = false;
            return;
          }
          time--;
          this.codeBtnText = time + "s后重发";
          this.btnDisabled = true;
        }, 1000);
      });
    },
    handleSendCode(name) {
      this.$refs[name].validateField("phone", (valid) => {
        if (!valid) {
          var params = {
            phone: this.userData.phone,
            type: 3,
          };
          postData("student/sendSmsCode", params).then((res) => {
            this.$Message.success("发送成功,请注意查收");
            var time = 60;
            this.codeBtnText = time + "s后重发";
            var timer = setInterval(() => {
              if (time <= 0) {
                clearInterval(timer);
                this.codeBtnText = "点击发送";
                this.btnDisabled = false;
                return;
              }
              time--;
              this.codeBtnText = time + "s后重发";
              this.btnDisabled = true;
            }, 1000);
          });
        } else {
        }
      });
    },

    handleSubmit(name) {
      const { userData } = this;
      this.$refs[name].validate((valid) => {
        if (valid) {
          var params = {
            phone: userData.phone,
            vercode: userData.code,
          };
          this.btnLoading = true;
          postData("student/checkSmsCode", params)
            .then((res) => {
              this.btnLoading = false;
              this.btnLoading = true;
              postData("student/bindPhone", params)
                .then((res) => {
                  this.userData.code = "";
                  this.$Message.success("绑定成功");
                  this.btnLoading = false;
                  this.isApprove = true;
                  this.userInfo.phone = userData.phone;
                })
                .catch((err) => {
                  this.btnLoading = false;
                });
            })
            .catch((err) => {
              this.btnLoading = false;
            });
        }
      });
    },
  },
};
</script>
<style>
.footerBtn button {
  margin-top: 12px;
  color: #fff;
  cursor: pointer;
  outline: none;
  border: none;
  width: 100%;
  height: 40px;
  background: rgba(55, 188, 95, 1);
  border-radius: 3px;
}
.unbindModal .ivu-modal-content {
  padding: 0px 20px;
}

.unbindModal .closeIcon {
  cursor: pointer;
  position: absolute;
  top: -30px;
  right: -30px;
  height: 30px;
  width: 30px;
}
.phoneBind .code .ivu-input {
  width: 220px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.unbindModal .unphone {
  color: rgba(34, 34, 34, 1);
  margin-bottom: 20px;
  margin-top: 40px;
}
.unbindModal .unphone i {
  margin-left: 20px;
  color: rgba(153, 153, 153, 1);
}
.unbindModal .send button {
  height: 36px;
  line-height: 36px;
}
.unbindModal .ivu-input {
  height: 36px;
  line-height: 36px;
}
.unbindModal .code .ivu-input {
  width: 240px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.unbindModal .code .ivu-btn {
  border-color: #dcdee2;
  border-left: none;
  color: #31af58;
  outline: none;
  background: rgba(250, 250, 250, 1);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  width: 100px;
}
.phoneBind .code .ivu-btn {
  border-color: #dcdee2;
  border-left: none;
  color: #31af58;
  outline: none;
  background: rgba(250, 250, 250, 1);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  width: 100px;
}
.phoneBind .code .ivu-form-item-content {
  margin-left: 0px !important;
}
.phoneBind .ivu-form-item:last-child .ivu-form-item-content {
  margin-left: 20px !important;
}
.phoneBind .ivu-form-item:nth-child(2) {
  /* margin-left: 20px !important; */
  display: flex;
}
.phoneBind #save {
  text-align: left;
}
.phoneBind .ivu-input {
  height: 36px;
}
.phoneBind .ivu-select-selection {
  text-align: left;
  height: 36px !important;
  line-height: 36px;
}
.ivu-select-placeholder {
  height: 36px !important;
  line-height: 36px;
}
.phoneBind .send .ivu-form-item-content {
  margin-left: 0 !important;
}

.phoneBind .send button {
  height: 36px;
}
.phoneBind .confirm {
  margin-top: 10px;
  width: 120px;
  height: 40px;
  line-height: 40px;
  background: rgba(49, 175, 88, 1);
  border-radius: 4px;
  border: none;
}
.phoneBind .back {
  background: rgba(34, 34, 34, 1);
  margin-top: 10px;
  width: 100px;
  height: 40px;
  line-height: 40px;
  border-radius: 4px;
  border: none;
}
</style>
<style lang="scss" scoped>
.phoneBind {
  .idSuccess {
    .info {
      color: #999999;
      margin-bottom: 30px;
    }
    img {
      border: 1px dashed #aaa;
      margin-top: 115px;
    }
    span {
      display: block;
      color: #31af58;
      margin-bottom: 20px;
      margin-top: 5px;
    }
  }
  .mid {
    text-align: center;
    .lineb {
      display: inline-block;
      width: 26px;
      height: 2px;
      background: rgba(187, 187, 187, 1);
      margin-bottom: 40px;
    }
    h2 {
      margin-top: 110px;
      margin-bottom: 20px;
      font-size: 30px;
      color: rgba(34, 34, 34, 1);
    }
    .from {
      display: inline-block;
      margin-bottom: 115px;
      width: 520px;
      input {
        width: 50px;
      }
    }
  }
}
</style>
